<template>
  <section class="container">
    <div class="row">
      <div class="col-md-2 " v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
          <adminSidenav />
        </div>
      <div class="col">
        
        <div class="">
          <h3>자료집 업로드</h3>
          <div v-if="isAdmin">
            <form @submit.prevent="submit">
              <div class="form-group">
                <input type="text" v-model="title" class="form-control" placeholder="제목" required />
              </div>
              <div class="form-group">
                <div class="quill-editor">
                  <quill-editor style="height: 250px" v-model="description" :options="editorOption" />
                </div>
              </div>
              <div class="form-group">
                <input type="file" ref="file" class="form-control" required />
              </div>
              <div class="form-btn-row text-center">
                <button class="btn btn-primary" type="submit" :disabled="uploading">업로드</button>
                <button class="btn btn-secondary ml-2" @click="$router.push({name: 'archiveList'})" type="button">취소</button>
              </div>
            </form>
          </div>
          <div v-else class="alert alert-danger mt-3">관리자만 업로드할 수 있습니다.</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'
import adminSidenav from '@/components/admin/Sidenav.vue'
export default {
  name: 'ArchiveUpload',
  components: { quillEditor, adminSidenav },
  data() {
    return {
      title: '',
      description: '',
      baseUrl: process.env.VUE_APP_ARCHIVE_API_URL || '/api/v1/archive',
      uploading: false,
      editorOption: {
        modules: {
          toolbar: [
            [{ 'size': ['small', false, 'large'] }],
            ['bold', 'italic'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image']
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
        },
        placeholder: '설명을 입력하세요',
      }
    }
  },
  methods: {
    submit() {
      if (!this.title || !this.description) {
        alert('제목과 설명을 입력하세요.');
        return;
      }
      const file = this.$refs.file.files[0];
      if (!file) {
        alert('파일을 선택하세요.');
        return;
      }
      const user = this.$auth && this.$auth.user && this.$auth.user();
      if (!user || !user.name) {
        alert('로그인 정보가 올바르지 않습니다.');
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('req', new Blob([JSON.stringify({
        title: this.title,
        description: this.description
      })], { type: 'application/json' }));
      const token = localStorage.getItem('token') || (this.$auth && this.$auth.token && this.$auth.token());
      this.uploading = true;
      this.axios.post(`${this.baseUrl}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-USER': user.id,
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        }
      }).then(() => {
        this.uploading = false;
        this.$router.push({name: 'archiveList'});
      }).catch(err => {
        this.uploading = false;
        let msg = '업로드에 실패했습니다.';
        if (err.response && err.response.data && err.response.data.detail) {
          msg += '\n' + err.response.data.detail;
        } else if (err.message) {
          msg += '\n' + err.message;
        }
        alert(msg);
        console.error('업로드 에러:', err);
      });
    }
  },
  computed: {
    isAdmin() {
      const user = this.$auth && this.$auth.user && this.$auth.user();
      if (!user) return false;
      // roleNames이 배열 또는 문자열일 수 있음
      if (Array.isArray(user.roleNames)) {
        return user.roleNames.includes('ADMIN') ;
      } else if (typeof user.roleNames === 'string') {
        return user.roleNames === 'ADMIN' ;
      }
      return false;
    }
  }
}
</script>
<style scoped>
/* 어드민 사이드바와 본문이 한 줄에 나오도록 레이아웃 조정 */
.sidebar-col {
  background: #f8f9fa;
  min-height: 100vh;
  border-right: 1px solid #e0e0e0;
  padding: 0;
}
.main-col {
  background: #f5f7fa;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
}
.content-wrap {
  width: 100%;
  max-width: 700px;
  margin: 32px auto 0 auto;
  padding: 24px 8px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.form-group {
  margin-bottom: 18px;
}
.form-btn-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 18px;
}
.btn {
  min-width: 110px;
}
.alert-danger { background: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; padding: 12px 16px; border-radius: 6px; }
@media (max-width: 768px) {
  .sidebar-col {
    display: none !important;
  }
  .main-col {
    min-width: 100vw;
    padding: 0;
  }
  .content-wrap {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 10px 2px;
  }
  .form-btn-row {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }
  .btn {
    min-width: 100%;
  }
}
</style>